import React from "react";
import RestartIcon from "../../../../images/restart-circle.svg?react";
import BaseCircleIconButton from "../BaseCircleIconButton";
import PropTypes from "prop-types";

function RestartButton(props) {
  let { onClick } = props;
  const tooltipText = "Retry";

  let icon = <RestartIcon id="restart-circle-button" onClick={onClick} />;

  return <BaseCircleIconButton icon={icon} tooltipText={tooltipText} />;
}

RestartButton.propTypes = {
  onClick: PropTypes.func,
};

export default RestartButton;
